import React from "react";
import BaseLayout from "./layouts/baseLayout";

const App = () => <BaseLayout />;

export default App;
